import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

export type SeqLogLevel = 'Verbose' | 'Debug' | 'Information' | 'Warning' | 'Error' | 'Fatal';

export interface SeqProperties {
  [key: string]: any;
}

@Injectable({
  providedIn: 'root'
})
export class SeqLogService {
  // Use HttpBackend to bypass interceptors and avoid infinite loops
  readonly #http: HttpClient;

  constructor(backend: HttpBackend) {
    this.#http = new HttpClient(backend);
  }

  private post(level: SeqLogLevel, messageTemplate: string, properties: SeqProperties = {}, exception?: string): void {
    const payload = {
      Events: [
        {
          Timestamp: new Date().toISOString(),
          MessageTemplate: messageTemplate,
          Level: level,
          ...(exception ? { Exception: exception } : {}),
          Properties: {
            ...properties,
            Host: 'CPQ'
          }
        }
      ]
    };

    this.#http.post(environment.seqUrl, payload).subscribe({
      error: (err) => console.warn('Failed to log to SEQ:', err)
    });
  }

  verbose(messageTemplate: string, properties?: SeqProperties): void {
    this.post('Verbose', messageTemplate, properties);
  }

  debug(messageTemplate: string, properties?: SeqProperties): void {
    this.post('Debug', messageTemplate, properties);
  }

  info(messageTemplate: string, properties?: SeqProperties): void {
    this.post('Information', messageTemplate, properties);
  }

  warn(messageTemplate: string, properties?: SeqProperties): void {
    this.post('Warning', messageTemplate, properties);
  }

  error(messageTemplate: string, properties?: SeqProperties, exception?: string): void {
    this.post('Error', messageTemplate, properties, exception);
  }

  fatal(messageTemplate: string, properties?: SeqProperties, exception?: string): void {
    this.post('Fatal', messageTemplate, properties, exception);
  }

  logHttpError(err: any, method: string, url: string, requestBody?: any, headers?: Record<string, string>, user?: string): void {
    const errorMessage =
      err.error?.message
      || err.error?.title
      || err.error?.error
      || err.message
      || err.statusText
      || 'Unknown error';

    this.error(
      'HTTP {StatusCode} {Method} {Url} failed: {ErrorMessage}',
      {
        StatusCode: err.status ?? 0,
        Method: method,
        Url: url,
        ErrorMessage: errorMessage,
        ...(user ? { User: user } : {}),
        ...(requestBody ? { RequestBody: typeof requestBody === 'string' ? requestBody : JSON.stringify(requestBody) } : {}),
        ...(headers ? { RequestHeaders: headers } : {})
      },
      err.error?.stack ?? undefined
    );
  }
}
